import { render, staticRenderFns } from "./CreateStockIn.vue?vue&type=template&id=e70a4c1c&scoped=true"
import script from "./CreateStockIn.vue?vue&type=script&lang=js"
export * from "./CreateStockIn.vue?vue&type=script&lang=js"
import style0 from "./CreateStockIn.vue?vue&type=style&index=0&id=e70a4c1c&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "../../../assets/styles/inventory.css?vue&type=style&index=2&id=e70a4c1c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70a4c1c",
  null
  
)

export default component.exports